var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconShaped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.082C7.64583 11.082 7.77344 11.0273 7.88281 10.918C7.99219 10.8086 8.04688 10.681 8.04688 10.5352C8.04688 10.3893 7.99219 10.2617 7.88281 10.1523C7.77344 10.043 7.64583 9.98828 7.5 9.98828C7.35417 9.98828 7.22656 10.043 7.11719 10.1523C7.00781 10.2617 6.95312 10.3893 6.95312 10.5352C6.95312 10.681 7.00781 10.8086 7.11719 10.918C7.22656 11.0273 7.35417 11.082 7.5 11.082ZM7.03125 8.83203H7.96875V4.72266H7.03125V8.83203ZM5.15625 13.5977L1.875 10.3164V5.62891L5.15625 2.34766H9.84375L13.125 5.62891V10.3164L9.84375 13.5977H5.15625ZM5.54688 12.6602H9.45312L12.1875 9.92578V6.01953L9.45312 3.28516H5.54688L2.8125 6.01953V9.92578L5.54688 12.6602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconShaped);
export default __webpack_public_path__ + "static/media/InfoIconShaped.c9b91e72838c70c445883d58bb349364.svg";
export { ForwardRef as ReactComponent };